<div class="email-verification-dialog">
  <si-generic-dialog [(displayDialog)]="displayDialog"
                     (displayDialogChange)="onChangeDisplayDialog($event)"
                     dialogTitle="SI_IDENTITY_VERIFICATION"
                     dialogImg="assets/images/email_second_validation.png"
                     [dialogText]="'SI_IDENTITY_VERIFICATION_EMAIL_INFO' | translate: {email: GenericFunctionsUtil.getEmailMasked(2, '*', emailValue || '')}"
                     [closable]="false"
                     button1Text="SI_VALIDATE"
                     button1Class="si-button_main"
                     [button1Close]="false"
                     [button1Disabled]="emailVerificationForm?.invalid"
                     button2Text="SI_CANCEL"
                     button2Class="si-button_secondary"
                     (updateButton1Change)="onClickValidate()">
    <div class="mt-3">
      <form #emailVerificationForm="ngForm"
            id="emailVerificationForm"
            name="emailVerificationForm">
        <div>
          <si-input id="emailVerificationCode"
                    name="emailVerificationCode"
                    text="SI_CODE"
                    placeholder="SI_WRITE_HERE"
                    [(model)]="emailVerificationCode"
                    [autoFocus]="true"
                    rule="generic.fieldNotNull"
                    [validationExternalErrorText]="emailVerificationErrorText"
          ></si-input>
        </div>
      </form>
    </div>
  </si-generic-dialog>
</div>
